var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"xs":"12","sm":"12","md":"12","lg":"12"}},[_c('WaitinglistTable',{on:{"item-delete":_vm.onItemDelete}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }